<header
  class="text-white bg-base-primary sticky t-0 transition-shadow min-h-[75px] z-[1600] bg-center bg-cover bg-no-repeat"
  style="background-image: url('assets/images/textura.webp')"
  [ngClass]="{ 'shadow-[0_2px_8px_0_rgba(26,26,26,0.6)]': !isScrollTop }"
>
  <div
    class="margin-responsive items-center flex justify-center md:justify-between min-h-inherit"
    *ngIf="config$ | async as config"
  >
    <!-- Institutional informations link -->
    <div class="hidden md:flex md:flex-wrap md:gap-x-8 md:gap-y-4">
      <a
        *ngFor="let item of config.plugin.handler.scaffold.institutional"
        [href]="item.href"
        target="_blank"
        class="text-white text-2xl font-medium no-underline hover:text-base-secondary"
      >
        {{ item.alt | translate }}
      </a>
    </div>

    <!-- Social Networks -->
    <app-labels-social-networks>
      <!-- E-class link -->
      <a
        [href]="config.plugin.handler.scaffold.portalUrl(config.school)"
        class="text-base-grey bg-white text-md rounded-full inline-flex py-2 px-4 gap-4 items-center no-underline mb-1 hover:text-base-blue"
        target="_blank"
      >
        <img alt="E-Class School" src="/assets/svg/eclass.svg" /> {{ 'global.portal_access' | translate }}
      </a>
    </app-labels-social-networks>
  </div>
</header>
